const pressRelease = {
  displayField: 'title',
  name: 'Press Release',
  description: '',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'slug',
      name: 'Slug',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'publicationDate',
      name: 'Publication Date',
      type: 'Date',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'author',
      name: 'Author',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'description',
      name: 'Description',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [
            'bold',
            'italic',
            'underline',
            'code',
            'superscript',
            'subscript'
          ],
          message: 'Only bold, italic, underline, code, superscript, and subscript marks are allowed'
        },
        {
          enabledNodeTypes: [
            'ordered-list',
            'unordered-list',
            'hr',
            'blockquote',
            'hyperlink',
            'entry-hyperlink',
            'asset-hyperlink'
          ],
          message: 'Only ordered list, unordered list, horizontal rule, quote, link to Url, link to entry, and link to asset nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'img',
      name: 'Hero Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'seo',
      name: 'SEO',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'seoPage' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'bodyText',
      name: 'Body',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic', 'underline', 'superscript', 'subscript' ],
          message: 'Only bold, italic, underline, superscript, and subscript marks are allowed'
        },
        {
          enabledNodeTypes: [
            'heading-3',
            'ordered-list',
            'unordered-list',
            'hr',
            'blockquote',
            'hyperlink',
            'entry-hyperlink',
            'asset-hyperlink',
            'embedded-entry-block'
          ],
          message: 'Only heading 3, ordered list, unordered list, horizontal rule, quote, link to Url, link to entry, link to asset, and block entry nodes are allowed'
        },
        {
          nodes: {
            'embedded-entry-block': [
              {
                linkContentType: [ 'imageStack', 'blogTextAndImage' ],
                message: null
              }
            ],
            'embedded-entry-inline': [
              {
                linkContentType: [ 'imageStack', 'blogTextAndImage' ],
                message: null
              }
            ]
          }
        }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'category',
      name: 'Category',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [ { in: [ 'Category 1', 'Category 2', 'Category 3' ] } ],
      disabled: true,
      omitted: false
    },
    {
      id: 'blogTags',
      name: 'Blog Tags',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: false,
      items: {
        type: 'Symbol',
        validations: [
          {
            in: [
              '2023',            'Americas',
              'Canada',          'Design Trends',
              'Engel & Völkers', 'Interior Design',
              'International',   'Lifestyle',
              'Living',          'Luxury',
              'New',             'News',
              'Real Estate',     'Sustainable',
              'Trends',          'Vintage',
              'Wellness',        'Private Residences',
              'Homes',           'Awards'
            ]
          }
        ]
      }
    }
  ],
  metadata: {
    annotations: {
      ContentType: [
        {
          sys: {
            id: 'Contentful:AggregateRoot',
            type: 'Link',
            linkType: 'Annotation'
          }
        }
      ]
    }
  },
  sys: {
    id: 'pressRelease',
    version: 6,
    updatedAt: '2023-10-17T20:24:32.946Z'
  }
};
export default pressRelease;